if (!customElements.get('back-in-stock-klaviyo')) {
  class BackInStockKlaviyo extends HTMLElement {
    constructor() {
      super();
      this.companyId = this.dataset.companyId;
      this.form = this.querySelector('form.back_in_stock');
      this.emailInput = this.querySelector('input[type="email"]');
      this.selectEl = this.querySelector('select');
      this.submitButton = this.form?.querySelector('[type="submit"]');
      this.fieldset = this.querySelector('.fieldset');

      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
    }

    getVariantId() {
      if (!this.selectEl) return null;
      const option = this.selectEl.options[this.selectEl.selectedIndex];
      return option ? option.getAttribute('option-id') : null;
    }

    showStatus(type, message) {
      this.querySelector('.back-in-stock__status')?.remove();
      const status = document.createElement('div');
      status.className =
        'back-in-stock__status form-status form__message' +
        (type === 'error' ? ' caption-medium text-body' : '');
      status.setAttribute('tabindex', '-1');
      if (type === 'error') status.setAttribute('role', 'alert');
      status.textContent = message;
      this.form.insertBefore(status, this.form.firstChild);
      status.focus();
    }

    async postToKlaviyo(payload) {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
        {
          method: 'POST',
          headers: {
            revision: '2024-07-15',
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.form.reportValidity()) return;

      const variantId = this.getVariantId();
      if (!variantId) {
        this.showStatus('error', this.dataset.textError);
        return;
      }

      const email = this.emailInput ? this.emailInput.value.trim() : '';
      this.submitButton?.setAttribute('disabled', '');

      try {
        await this.postToKlaviyo({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: { type: 'profile', attributes: { email: email } },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        });
        this.fieldset?.classList.add('hidden');
        this.showStatus('success', this.dataset.textSuccess);
      } catch {
        this.showStatus('error', this.dataset.textError);
      } finally {
        this.submitButton?.removeAttribute('disabled');
      }
    }
  }

  customElements.define('back-in-stock-klaviyo', BackInStockKlaviyo);
}
